import { render, staticRenderFns } from "./NccQuestionVideoBar.vue?vue&type=template&id=75f51296&scoped=true&"
import script from "./NccQuestionVideoBar.vue?vue&type=script&lang=js&"
export * from "./NccQuestionVideoBar.vue?vue&type=script&lang=js&"
import style0 from "./NccQuestionVideoBar.vue?vue&type=style&index=0&id=75f51296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f51296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f51296')) {
      api.createRecord('75f51296', component.options)
    } else {
      api.reload('75f51296', component.options)
    }
    module.hot.accept("./NccQuestionVideoBar.vue?vue&type=template&id=75f51296&scoped=true&", function () {
      api.rerender('75f51296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccQuestionVideoBar.vue"
export default component.exports